const context = "b2b";
const abrev = "b2b";

export default [
    {
        path: '/b2b/politica-comercial',
        name: `b2b-politica-comercial`,
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/b2b/politica-comercial/PoliticaComercial.vue'),
        children: [
            {
                path: 'list',
                name: `b2b-politica-comercial-list`,
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/b2b/politica-comercial/PoliticaComercialList.vue'),
                children: [
                    {
                        path: 'edit/:id/:idempresa',
                        name: `b2b-politica-comercial-edit`,
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/b2b/politica-comercial/PoliticaComercialManage.vue'),
                        children: [
                            {
                                path: 'geral',
                                name: `b2b-politica-comercial-geral`,
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/b2b/politica-comercial/abas/Geral.vue'),
                            },
                            {
                                path: 'relacao-com-cliente',
                                name: `b2b-politica-comercial-relacao-com-cliente`,
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/b2b/politica-comercial/abas/RelacaoComCliente.vue'),
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: '/b2b/parametrizacoes',
        name: `b2b-parametrizacoes`,
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/b2b/parametrizacoes/Parametrizacoes.vue'),
        children: [
            {
                path: 'edit',
                name: `b2b-parametrizacoes-edit`,
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/b2b/parametrizacoes/ParametrizacoesManage.vue')
            }
        ]
    },
];
